import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-651eeb88"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "py-2.5 px-3 rounded-lg shadow-lg bg-white mb-2" }
const _hoisted_2 = { class: "flex mt-1 mb-2" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "flex-grow ml-2" }
const _hoisted_5 = { class: "flex justify-between" }
const _hoisted_6 = { class: "text-xs text-gray-400" }
const _hoisted_7 = { class: "pt-2 overflow-hidden text-left break-all whitespace-pre-wrap max-h-20 overflow-ellipsis line-limit" }
const _hoisted_8 = { class: "flex justify-between mt-1" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "ml-1 text-xs text-gray-400" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "ml-1 text-xs text-gray-400" }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { class: "ml-1 text-xs text-gray-400" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_f_icon = _resolveComponent("f-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "flex-shrink-0 w-10",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleClickAvatar && _ctx.handleClickAvatar(...args)), ["stop"]))
      }, [
        _createElementVNode("img", {
          src: _ctx.processAvatar(_ctx.rating.creator.avatar),
          class: "w-10 h-10 rounded-full"
        }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", {
            class: "font-extrabold text-primary",
            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleClickAvatar && _ctx.handleClickAvatar(...args)), ["stop"]))
          }, _toDisplayString(_ctx.rating.creator.nickname), 1),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.timeDiff), 1)
        ]),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.rating.form.content), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", {
        class: _normalizeClass([_ctx.courseCardColor, "px-2 py-1 overflow-hidden text-xs rounded-2xl whitespace-nowrap overflow-ellipsis"])
      }, _toDisplayString(`${_ctx.rating.lecture.name} ${_ctx.rating.lecture.teachers.join(' ')}`), 3),
      _createElementVNode("div", null, [
        false
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
              _createElementVNode("span", null, [
                _createVNode(_component_f_icon, {
                  name: "reaction",
                  size: "14"
                })
              ]),
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.rating.reaction.count), 1)
            ]))
          : _createCommentVNode("", true),
        false
          ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
              _createVNode(_component_f_icon, {
                name: "chat",
                size: "14"
              }),
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.rating.commentCount), 1)
            ]))
          : _createCommentVNode("", true),
        false
          ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
              _createVNode(_component_f_icon, {
                style: _normalizeStyle({color: _ctx.starColor}),
                name: _ctx.rating.starred ? 'heart-fill' : 'heart',
                size: "14"
              }, null, 8, ["style", "name"]),
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.rating.starCount), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}